export const stringOrUndefined = (str: string | null | undefined): string | undefined =>
  str || undefined;
